import { Whatsapp, Telegram } from "react-bootstrap-icons";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

function CarDetails() {
  // const { id } = useParams();
  const { slug } = useParams();
  console.log("Slug from URL:", slug);

  const [car, setCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    axios
      // .get(`${process.env.REACT_APP_API_URL}/cars/${id}`)
      .get(`${process.env.REACT_APP_API_URL}/cars/slug/${slug}`)
      .then((res) => {
        setCar(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching car details:", err);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <p>Loading...</p>;
  if (!car) return <p>Car not found</p>;

  // Parse images safely
  let imageSrcs = [];
  try {
    imageSrcs = JSON.parse(car.images || "[]").map(
      (img) => `${process.env.REACT_APP_API_URL}${img}`
    );
  } catch (err) {
    console.error("Invalid JSON in car.images:", err);
  }

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % imageSrcs.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + imageSrcs.length) % imageSrcs.length);
  };

  return (
    <div className="container mt-4 mt-lg-5" style={{ maxWidth: "800px" }}> 
      {/* Main Image with Arrows */} 
      <div style={{ position: "relative", textAlign: "center" }}>
        {imageSrcs.length > 0 ? (
          <img
            src={imageSrcs[currentIndex]}
            alt={`${car.brand} ${car.model}`}
            className="img-fluid rounded"
            style={{ maxHeight: "420px", cursor: "pointer" }}
            onClick={() => setIsModalOpen(true)}
          />
        ) : (
          <img
            src="https://via.placeholder.com/400"
            alt={`${car.brand} ${car.model}`}
            className="img-fluid rounded"
          />
        )}

        {imageSrcs.length > 1 && (
          <>
            <button onClick={prevImage} style={arrowStyle("left")}>
              &#8249;
            </button>
            <button onClick={nextImage} style={arrowStyle("right")}>
              &#8250;
            </button>
          </>
        )}
      </div>

      {/* Thumbnails */} 
      {imageSrcs.length > 1 && (
        <div
          className="d-flex gap-2 mt-3 overflow-auto"
          style={{ whiteSpace: "nowrap" }}
        >
          {imageSrcs.map((src, idx) => (
            <img
              key={idx}
              src={src}
              alt={`${car.brand} ${car.model} - thumbnail ${idx + 1}`}
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                borderRadius: "6px",
                border:
                  idx === currentIndex
                    ? "2px solid #0d6efd"
                    : "2px solid transparent",
                cursor: "pointer",
              }}
              onClick={() => setCurrentIndex(idx)}
            />
          ))}
        </div>
      )}

      {/* Fullscreen Modal */}
      {isModalOpen && (
        <div style={modalOverlayStyle} onClick={() => setIsModalOpen(false)}>
          <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            <img
              src={imageSrcs[currentIndex]}
              alt="Full screen view"
              style={{ maxWidth: "90%", maxHeight: "90%" }}
            />
            {imageSrcs.length > 1 && (
              <>
                <button onClick={prevImage} style={arrowStyle("left", true)}>
                  &#8249;
                </button>
                <button onClick={nextImage} style={arrowStyle("right", true)}>
                  &#8250;
                </button>
              </>
            )}
            <button style={closeBtnStyle} onClick={() => setIsModalOpen(false)}>
              ✖
            </button>
          </div>
        </div>
      )}

      {/* Title & Seller */}
      <div className="mt-3">
        <h5 className="fw-semibold">
          {car.title} | {car.currency} {Number(car.price).toLocaleString()}
        </h5>
        {/* <p className="text-muted mb-0">
          {car.name} | <strong>{car.phone}</strong>
        </p> */}
        <div className="mt-2">
          <p className="text-muted mb-2">
            {car.name} | <strong>{car.phone}</strong>
          </p>

          <div className="d-flex gap-2 flex-wrap">
            {/* WhatsApp Button */}
            <a
              href={`https://wa.me/${car.phone.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success d-flex align-items-center gap-2 px-3"
            >
              <Whatsapp size={18} />
              WhatsApp
            </a>

            {/* Telegram Button */}
            <a
              href={`https://t.me/${car.phone.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary d-flex align-items-center gap-2 px-3"
            >
              <Telegram size={18} />
              Telegram
            </a>
          </div>
        </div>
      </div>

      {/* Car Details */}
      <div className="mt-4">
        <h6 className="fw-bold mb-3">Car Details</h6>
        <div className="row g-3">
          <div className="col-md-6">
            <ul className="list-group list-group-flush shadow-sm rounded">
              <li className="list-group-item"><strong>Brand:</strong> {car.brand}</li>
              <li className="list-group-item"><strong>Model:</strong> {car.model}</li>
              <li className="list-group-item"><strong>Year:</strong> {car.year}</li>
              <li className="list-group-item"><strong>Transmission:</strong> {car.transmission}</li>
              <li className="list-group-item"><strong>Body Type:</strong> {car.bodyType}</li>
              <li className="list-group-item"><strong>Color:</strong> {car.color}</li>
            </ul>
          </div>

          <div className="col-md-6">
            <ul className="list-group list-group-flush shadow-sm rounded">
              <li className="list-group-item"><strong>Condition:</strong> {car.condition}</li>
              <li className="list-group-item"><strong>Fuel:</strong> {car.fuel}</li>
              <li className="list-group-item"><strong>Engine Size:</strong> {car.engineSize} L</li>
              <li className="list-group-item"><strong>Price Type:</strong> {car.priceType}</li>
              <li className="list-group-item"><strong>Seller Type:</strong> {car.sellerType}</li>
              <li className="list-group-item"><strong>Location:</strong> {car.location}</li>
            </ul>
          </div>
          {/* Full-width Description */}
          <div className="col-12">
            <div className="card mt-2 mb-3 p-3">
              <strong>Description:</strong>
              <p className="mt-2 mb-0 text-secondary" style={{ whiteSpace: "pre-wrap" }}>
                {car.description || "No description provided."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* Styles */
const arrowStyle = (side, modal = false) => ({
  position: "absolute",
  top: "50%",
  [side]: "10px",
  transform: "translateY(-50%)",
  background: "rgba(0,0,0,0.5)",
  color: "white",
  border: "none",
  borderRadius: "50%",
  padding: modal ? "12px 16px" : "8px 12px",
  cursor: "pointer",
  fontSize: modal ? "24px" : "18px",
  zIndex: 10,
});

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalContentStyle = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

const closeBtnStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "rgba(0,0,0,0.5)",
  color: "white",
  border: "none",
  borderRadius: "50%",
  padding: "8px",
  cursor: "pointer",
  fontSize: "18px",
};

export default CarDetails;


